<template>
  <div class="njdd-area">
    <h3>农机调度系统</h3>
    <!-- 主要内容部分开始 -->
    <div class="main-body">
      <!-- 地图区域开始 -->
      <div class="map-area">
        <!-- <baiduMap :count="count" @mapChange="mapChange"></baiduMap> -->
        <MapViewer :count="count" @mapChange="mapChange"></MapViewer>
      </div>
      <!-- 地图区域结束 -->
      <!-- 我的机手列表开始 -->
      <div class="wdjs-area">
        <wdjs :orderData="orderData" @wdjsChange="wdjsChange"></wdjs>
      </div>
    </div>
    <!-- 地图区域结束 -->
  </div>
</template>
<script>
import MapViewer from './components/MapViewer.vue';
import baiduMap from "./components/baiduMap.vue";
import wdjs from "./components/wdjs.vue";
export default {
  components: {
    MapViewer,
    baiduMap,
    wdjs,
  },

  data() {
    return {
      count: 0,
      orderData:'',
    };
  },
  created() {
    localStorage.removeItem('machinistOrderInfo')
  },
  methods: {
    //我的机手组件传参
    wdjsChange(e) {
      console.log("我的机手传来的参数", e);
      if (e.code == 1) {
        console.log('count变化')
        this.count++;
      }
    },
    //地图变化
    mapChange(e){
      console.log('mapChange钩子',e)
     if(e.msg=='点击资源资产'){
      this.orderData=''
       this.orderData=JSON.parse(JSON.stringify(e.data))
       console.log('查看传过来的数据222222222222222222222222222222',   this.orderData)
     }else if(e.msg=='点击托管单'){
      console.log('点击托管单')
      this.orderData=''
      this.orderData=JSON.parse(JSON.stringify(e.data))
     }else if(e.msg=='信息窗口关闭'){
      console.log('信息窗口关闭')
      this.orderData=JSON.parse(JSON.stringify(e.data))
     }
    },
  },
};
</script>
<style lang="less" scoped>
.njdd-area {
  padding: 0 20px;
  .main-body {
    display: flex;
    .map-area {
      width: 70%;
    }
    .wdjs-area {
      width: 30%;
    }
  }
}
</style>
